import { LooseObject } from "../loose-object.model";

export class ProjectValidation {
  validInputs: number;
  invalidInputs: number;
  complete: boolean;
  tree: LooseObject;
  projectInfoPercentage: number;
  feedstockPercentage: number;
  plantSpecificationsPercentage: number;
  financialPercentage: number;
  ghgEmissionPercentage: number;
  errMsgs: string[] = [];

  getPercentage() {
    const p = 100 * (this.validInputs / (this.validInputs + this.invalidInputs));
    return Math.floor(p);
  }
}

export interface ProjectValidationUnitInterface {
  isValid: boolean;
  validFields: number;
  invalidFields: number;
  tree: LooseObject | ValidationItem;
}

export class ProjectValidationUnit {
  isValid: boolean;
  validFields: number;
  invalidFields: number;
  tree: LooseObject | ValidationItem;

  constructor(param: ProjectValidationUnitInterface = {
    isValid: true,
    validFields: 0,
    invalidFields: 0,
    tree: {}
  }) {
    this.isValid = param.isValid;
    this.validFields = param.validFields;
    this.invalidFields = param.invalidFields;
    this.tree = param.tree;
  }

  addModuleResults(validationUnit: ProjectValidationUnit, fieldName: string) {
    this.isValid = this.isValid && validationUnit.isValid;
    this.validFields += validationUnit.validFields;
    this.invalidFields += validationUnit.invalidFields;
    this.tree[fieldName] = validationUnit.tree;
  }

  addArrayToModuleResults(validationUnit: ProjectValidationUnit, fieldName: string, index: number, name: string) {
    this.isValid = this.isValid && validationUnit.isValid;
    this.validFields += validationUnit.validFields;
    this.invalidFields += validationUnit.invalidFields;
    if (!this.tree[fieldName]) {
      this.tree[fieldName] = {};
    }
    if (name) {
      this.tree[fieldName][name] = validationUnit.tree;
    } else {
      this.tree[fieldName][index] = validationUnit.tree;
    }
  }

  setValid(fieldName: string) {
    this.validFields++;
    this.tree[fieldName] = new ValidationItem(true);
  }

  setInvalid(fieldName: string, errMsgs: string[] = []) {
    this.isValid = false;
    this.invalidFields++;
    this.tree[fieldName] = new ValidationItem(false, fieldName, errMsgs);
  }

  validate(value, propName, errMsgs?) {
    if (value) {
      this.setValid(propName);
    } else {
      this.setInvalid(propName, [errMsgs || propName + ' must be set']);
    }
  }

}

export class ValidationItem {
  public isValid: boolean;
  public errMsgs = {};

  constructor(isValid: boolean, fieldName: string = null, errMsgs: string[] = []) {
    this.isValid = isValid;
    if (errMsgs.length > 0) {
      this.errMsgs[fieldName] = errMsgs;
    }
  }
}

export enum ValidationSectionName {
  ProjectInfo = 'INPUT_SUMMARY.PROJECT.PROJECT_INFO',
  Feedstock = 'INPUT_SUMMARY.PROJECT.FEEDSTOCK',
  PlantSpecifications = 'INPUT_SUMMARY.PROJECT.PLANT_SPECIFICATION',
  Financial = 'INPUT_SUMMARY.PROJECT.FINANCIAL',
  GhgEmissions = 'INPUT_SUMMARY.PROJECT.GHG_EMISSIONS',
  All = 'overall'
}

export enum GenericErrors {
  MissingName = 'VALIDATION.NAME_REQUIRED',
  MissingType = 'VALIDATION.TYPE_REQUIRED',
}
